import React from "react";

import Datepicker from "../../../general-ui/datepicker/datepicker";
import Timepicker from "../../../general-ui/time-picker/timepicker";

interface SessionStartTimeFieldProps {
	minDate?: Date,
	handleSetDate: (date: Date) => void,
	workingStartDate?: Date,
	handleSetDuration: (minutes: number) => void,
	duration?: number,
}

const SessionStartTimeFields: React.FC<SessionStartTimeFieldProps> = ({
	minDate,
	handleSetDate,
	workingStartDate,
	handleSetDuration,
	duration,
}) => {
	return (
		<div className="field-group broadcast-group">
			<div className="broadcast-date">
				<Datepicker
					label={"Date & Time *"}
					minDate={minDate}
					onChange={handleSetDate}
					placeholder="Select a date and time"
					portalId="date-portal"
					value={workingStartDate}
				/>
			</div>
			<div className="broadcast-time">
				<Timepicker
					onChange={(e) => handleSetDuration(e.target.valueAsNumber)}
					label={"Duration (minutes) *"}
					placeholder={"Enter a duration in minutes"}
					initialValue={duration}
				/>
			</div>
		</div>
	);
};

export default SessionStartTimeFields;
